// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"svg-icon_buttonWrapper__2aieu","svgIcon":"svg-icon_svgIcon__13Z8z","iconHamburger":"svg-icon_iconHamburger__1uk47"};